import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useRef } from "react";
import { Grid, Box, Typography, Button } from "@mui/material";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import BreadCrumb from "../../components/Common/BreadCrumb";
import Select from "react-select";
import consumerNo from "../../assets/images/consumerNo.svg";
import divMarker from "../../assets/images/divMarker.svg";
import NotificationManager from "../../components/Common/NotificationManager";
import links from "./FooterPages/data";
import NewFooter from "../../Layouts/NewFooter";
import NewHeader from "../../Layouts/NewHeader";
import API from "../../helpers/API";

const FormPreview = (props) => {
  const [loading, setLoading] = useState(false);
  const { consumerData, rechargeOptions } = props;
  const formikRef = useRef();
  const history = useHistory();

  return (
    <>
      <div
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh", overflowX: "hidden" }}
      >
        <NewHeader />
        <div
          className="mt-4 p-5"
          style={{
            background:
              "linear-gradient(180deg, rgba(23, 0, 0, 0.80) 28.15%, rgba(0, 11, 5, 0.80) 99.2%)",
            backdropFilter: "blur(30px)",
          }}
        >
          <h5 style={{ color: "#FFF", fontSize: "25px", fontWeight: "700" }}>
            Prepaid Electricity Recharge
          </h5>
        </div>
        <div className="container mx-1" style={{ flex: "1" }}>
          <Grid container>
            <Grid item lg={9} xs={12}>
              <div
                className="card px-5 py-5 my-3 mx-2 m-auto shadow-lg position-relative"
                style={{
                  top: "-40px",
                  borderRadius: "10px",
                  margin: "auto !important",
                }}
              >
                <div>
                  <Formik
                    innerRef={formikRef}
                    initialValues={{
                      division: consumerData?.division,
                      consumer: consumerData?.consumerno,
                      recharge: "",
                      mobile: consumerData?.phone,
                      email: consumerData?.email,
                    }}
                    onSubmit={() => {}}
                  >
                    {({ values, errors, touched, setFieldValue }) => (
                      <Form className="av-tooltip tooltip-label-bottom">
                        <Grid>
                          {/* Division and Consumer Number */}
                          <Grid container spacing={2}>
                            <Grid item lg={6} xs={12} className="mt-2 mb-2">
                              <div className="mb-3">
                                <label
                                  htmlFor="division"
                                  className="form-label"
                                  style={{
                                    color: "#9e9e9e",
                                    fontSize: "14px",
                                  }}
                                >
                                  Division
                                </label>
                                <div className="input-container position-relative">
                                  <Field
                                    className="form-control"
                                    name="division"
                                    style={{
                                      borderRadius: "0",
                                      border: "none",
                                      borderBottom: "1px solid #9e9e9e",
                                      background: "transparent",
                                      paddingLeft: "20px",
                                    }}
                                    onMouseOver={(e) =>
                                      (e.target.style.borderColor = "#26a69a")
                                    }
                                    onMouseOut={(e) =>
                                      (e.target.style.borderColor = "#9e9e9e")
                                    }
                                    onClick={(e) =>
                                      (e.target.style.borderColor = "#26a69a")
                                    }
                                    disabled
                                  />
                                  <div
                                    className="icon-container position-absolute"
                                    style={{ bottom: "8px" }}
                                  >
                                    <img src={divMarker} alt="" />
                                  </div>
                                </div>
                              </div>
                            </Grid>

                            <Grid item lg={6} xs={12} className=" mt-2 mb-2">
                              <div className="mb-3">
                                <label
                                  htmlFor="consumer"
                                  className="form-label"
                                  style={{
                                    color: "#9e9e9e",
                                    fontSize: "14px",
                                  }}
                                >
                                  Consumer No or Meter No
                                </label>
                                <div className="input-container position-relative">
                                  <Field
                                    className="form-control"
                                    name="consumer"
                                    style={{
                                      borderRadius: "0",
                                      border: "none",
                                      borderBottom: "1px solid #9e9e9e",
                                      background: "transparent",
                                      paddingLeft: "20px",
                                    }}
                                    onMouseOver={(e) =>
                                      (e.target.style.borderColor = "#26a69a")
                                    }
                                    onMouseOut={(e) =>
                                      (e.target.style.borderColor = "#9e9e9e")
                                    }
                                    onClick={(e) =>
                                      (e.target.style.borderColor = "#26a69a")
                                    }
                                    disabled
                                  />
                                  <div
                                    className="icon-container position-absolute"
                                    style={{ bottom: "8px" }}
                                  >
                                    <img src={consumerNo} alt="" />
                                  </div>
                                </div>
                              </div>
                            </Grid>
                          </Grid>

                          {/* Recharge Amount & Mobile Number */}
                          <Grid container spacing={2}>
                            <Grid item lg={6} xs={12} className="mt-2 mb-2">
                              <div className="mb-3">
                                <label
                                  htmlFor="recharge"
                                  className="form-label"
                                  style={{
                                    color: "#9e9e9e",
                                    fontSize: "14px",
                                  }}
                                >
                                  Recharge amount
                                </label>
                                <div className="input-container position-relative">
                                  <Field
                                    className="form-control"
                                    name="recharge_amount"
                                    style={{
                                      borderRadius: "0",
                                      border: "none",
                                      borderBottom: "1px solid #9e9e9e",
                                      paddingLeft: "20px",
                                      background: "transparent",
                                    }}
                                    onMouseOver={(e) =>
                                      (e.target.style.borderColor = "#26a69a")
                                    }
                                    onMouseOut={(e) =>
                                      (e.target.style.borderColor = "#9e9e9e")
                                    }
                                    onClick={(e) =>
                                      (e.target.style.borderColor = "#26a69a")
                                    }
                                    disabled
                                  />
                                  <div
                                    className="icon-container position-absolute"
                                    style={{ bottom: "8px" }}
                                  >
                                    <img
                                      src={"/money.svg"}
                                      alt=""
                                      style={{ color: "#999999" }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </Grid>
                            <Grid item lg={6} xs={12} className="mt-2 mb-2">
                              <label
                                htmlFor="mobile"
                                className="form-label"
                                style={{
                                  color: "#9e9e9e",
                                  fontSize: "14px",
                                }}
                              >
                                Mobile No
                              </label>
                              <div className="input-container position-relative">
                                <Field
                                  className="form-control"
                                  name="mobile"
                                  style={{
                                    borderRadius: "0",
                                    border: "none",
                                    borderBottom: "1px solid #9e9e9e",
                                    paddingLeft: "20px",
                                    background: "transparent",
                                  }}
                                  onMouseOver={(e) =>
                                    (e.target.style.borderColor = "#26a69a")
                                  }
                                  onMouseOut={(e) =>
                                    (e.target.style.borderColor = "#9e9e9e")
                                  }
                                  onClick={(e) =>
                                    (e.target.style.borderColor = "#26a69a")
                                  }
                                  disabled
                                />
                                <div
                                  className="icon-container position-absolute"
                                  style={{ bottom: "8px" }}
                                >
                                  <img src={"/mobile.svg"} alt="" />
                                </div>
                              </div>
                            </Grid>
                          </Grid>

                          {/* Email */}
                          <Grid container spacing={2}>
                            <Grid item lg={6} xs={12} className="mb-2">
                              <label
                                htmlFor="email"
                                className="form-label"
                                style={{
                                  color: "#9e9e9e",
                                  fontSize: "14px",
                                }}
                              >
                                Email
                              </label>
                              <div className="input-container position-relative">
                                <Field
                                  className="form-control"
                                  name="email"
                                  style={{
                                    borderRadius: "0",
                                    border: "none",
                                    borderBottom: "1px solid #9e9e9e",
                                    paddingLeft: "20px",
                                  }}
                                  onMouseOver={(e) =>
                                    (e.target.style.borderColor = "#26a69a")
                                  }
                                  onMouseOut={(e) =>
                                    (e.target.style.borderColor = "#9e9e9e")
                                  }
                                  onClick={(e) =>
                                    (e.target.style.borderColor = "#26a69a")
                                  }
                                />
                                <div
                                  className="icon-container position-absolute"
                                  style={{ bottom: "8px" }}
                                >
                                  <img src={"/sms.svg"} alt="" />
                                </div>
                              </div>
                            </Grid>
                          </Grid>
                        </Grid>

                        {/* Buttons */}

                        <Grid container spacing={2} className="mt-2">
                          <Grid item lg={2}>
                            <Button
                              fullWidth
                              className="btn my-2"
                              onClick={() => {
                                history.goBack();
                              }}
                              style={{
                                color: "black",
                                fontWeight: 500,
                                fontSize: "15px",
                                background: "#D3D3D3",
                                borderRadius: "5px",
                                boxShadow:
                                  "0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)",
                                textTransform: "capitalize",
                              }}
                              onMouseOver={(e) =>
                                (e.target.style.background = "darkgrey")
                              }
                              onMouseOut={(e) =>
                                (e.target.style.background = "lightgrey")
                              }
                            >
                              Go Back
                            </Button>
                          </Grid>
                          {loading ? (
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              <span className="sr-only">Loading...</span>
                            </div>
                          ) : (
                            <Grid item lg={2}>
                              <Button
                                fullWidth
                                className="btn my-2"
                                type="submit"
                                style={{
                                  color: "white",
                                  fontWeight: 500,
                                  fontSize: "15px",
                                  background:
                                    "linear-gradient(90deg, #433232 5.56%, #383735 95.49%)",
                                  borderRadius: "5px",
                                  boxShadow:
                                    "0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)",
                                  textTransform: "capitalize",
                                }}
                              >
                                Pay Now
                              </Button>
                            </Grid>
                          )}
                        </Grid>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
        <NewFooter />
      </div>
    </>
  );
};

export default FormPreview;
